import AutoComplete from './autocomplete';

export default class autoCompleteLoader {
    constructor(el, app) {
        this.app = app;
        this.autocompleter = new AutoComplete();

        this.boot();
    }

    boot() {
        this.autocompleter.boot();
        this.init();
    }

    /**
     * Setup the autocomplete handler for the search field
     */
    init() {
        this.autocompleter.start(".searchInput", {
            serviceUrl: `${window.location.origin}/search/suggester`,
            minChars: 1,
            delimiter: /(,|;)\s*/,
            maxHeight: 400,
            width: 340,
            zIndex: 9999,
            deferRequestBy: 0,
            containerEl: $("header .searchResults"),
            onSelect: (data, value) => {
                window.location.href = value;
            }
        });
    }
}

$(document).ready(function () {
    new autoCompleteLoader();

    const $blogSuggestions = $('.blog-suggestions');

    $blogSuggestions.on('mouseenter', 'li', function() {
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');
    });

    $blogSuggestions.on('mouseleave', function() {
        $(this).find('li').removeClass('selected');
    });
});
